const firebaseConfig = {
    apiKey: "AIzaSyCmqIzhrgCRXjZPUnBavu2Lk5OEvHvOQo8",
    authDomain: "health-care-e4dbc.firebaseapp.com",
    projectId: "health-care-e4dbc",
    storageBucket: "health-care-e4dbc.appspot.com",
    messagingSenderId: "287874627154",
    appId: "1:287874627154:web:b2526e5b2b24e6e7fe918b"
};

export default firebaseConfig;